import React, { useState } from 'react';
import { Grid, Button, Paper, IconButton, Collapse } from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { useDispatch } from 'react-redux';
import { ExitButton } from '../../../../utils/etc';
import { SelectWithLabel } from '../../../../utils/selectWithLabel';
import { formatPaxName } from '../modalFunctions';
import { editPax } from '../../../../store/dcs'
import { StatusList } from './etc'
import { PhoneEdit, WeightEdit, AddRemark } from './PhoneWeightRemarkEdits'
import ApfaxEdit from './ApfaxEdit'
import _ from 'lodash';

const removeReservedChars = (string) => {
  return string.split(',').join('').split('<').join('').split('>').join('').split('&').join('').split('\'').join('').split('\"').join('')
}

const EditPaxModal = (props) => {
  const modalClasses = props.modalClasses
  const dispatch = useDispatch()
  const closeModal = props.closeModal
  const flight = props.flight
  const paxInfo = flight.passengers
  const [selectedPax, setSelectedPax] = useState('')
  const [openPhoneWeight, setOpenPhoneWeight] = useState(false)
  const [openApfaxEdit, setOpenApfaxEdit] = useState(false)
  const [openAddRemark, setOpenAddRemark] = useState(false)
  const [openStatusEdit, setOpenStatusEdit] = useState(false)
  // NOTE // each property in editData should be an object after being set with the properties of the values needed for the api call (i.e. apfax: {rloc: 'AAAAJB', editData: {fact: fact, flightNumber: flight.FlightNumber, origin: flight.Origin, destination: flight.Destination}})
  const [newData, setNewData] = useState({phone: '', weight: '', apfax: '', status: '', remark: ''})

  const passengerChoices = [{label: 'None', value: ''}].concat(paxInfo.map(pax => {
    return {label: `${formatPaxName(pax)} (${pax.PNRRefNo})`, value: pax}
  }))

  // NOTE // final checks before dispatching requests. Basically checking that new data is there, and that it is not the same as the old data
  const saveChanges = (selectedPax, newData, setOpenStatusEdit) => {
    if (selectedPax) {
      if (newData.phone) {
        let originalPhone = selectedPax.phone || ''
        let newPhone = newData.phone && newData.phone.editData ? newData.phone.editData.phoneNumber : ''
        // NOTE //if there is a new phone number that is different from the old phone, dispatch the edit
        if (newPhone && newPhone !== originalPhone) {
          dispatch(editPax(newData.phone))
        }
      }
      if (newData.weight) {
        let originalWeight = selectedPax.weight || ''
        let newWeight = newData.weight && newData.weight.editData ? newData.weight.editData.weight : ''
        // NOTE //if there is a new weight that is different from the weight, dispatch the edit
        if (newWeight && newWeight !== originalWeight) {
          dispatch(editPax(newData.weight))
        }
      }
      if (newData.remark) {
        // {editData: {comment: data}, rloc: pax.PNRRefNo, type: 'addRemark', airlineId: ''}
        let remarkCopy = _.cloneDeep(newData.remark)
        // NOTE // remove any reserved characters
        remarkCopy.editData.comment = removeReservedChars(remarkCopy.editData.comment)
        dispatch(editPax(remarkCopy))
      }
    }

    if (newData.apfax) {
      dispatch(editPax(newData.apfax))
    }

    setOpenStatusEdit(true)
  }

  // NOTE // on changing the selected passenger, reset editData
  const handleChangePax = (data) => {
    setSelectedPax(data)
    setNewData({phone: '', weight: '', apfax: '', status: '', remark: ''})
  }

  // NOTE // sets the data for a single property in editData (i.e. changeEditData('211-867-5309', 'phone'))
  // NOTE // changeEditData should only be called when the form data meets the requirements for the api call
  const changeNewData = (data, type) => {
    let newDataCopy = _.cloneDeep(newData)
    newDataCopy[type] = data
    setNewData(newDataCopy)
  }

  return (
    <Grid container justify="center" alignContent="center" style={{marginTop: '10%'}}>
      {openStatusEdit === false ? 
        <Paper className={modalClasses.paper}>
          <Grid id="modal-header" container item xs={12} justify="center" className={modalClasses.modalHeader}>
            <Grid item xs={2} lg={4}></Grid>
            <Grid container justifyContent="center" item xs={8} lg={4}>
              <h5 style={{margin: "0px", paddingTop: "12px"}}>
                {flight.FlightNumber + " Edit Pax"}
              </h5>
            </Grid>
            <Grid item xs={1} lg={3}></Grid>
            <Grid container alignContent="flex-start" justifyContent="flex-end" style={{paddingRight: '8px'}} item xs={1}>
              <ExitButton exit={closeModal} />
            </Grid>
          </Grid>
          <Grid container justifyContent="center" item xs={12} style={{paddingTop: '5px', paddingBottom: '5px'}} id="passenger-select">
            <SelectWithLabel defaultVal={selectedPax} handleChange={(e) => {handleChangePax(e.target.value)}} inputLabel={'Passenger'} items={passengerChoices} customStyle={{width: '30%'}}/>
          </Grid>
          <Grid item xs={1}></Grid>
          {/* NOTE // Idk where the hell it's coming from, but without the margin: 0px here, it isn't using grid correctly */}
          <Grid id="edit-sections" container justifyContent="center" item xs={11} style={{margin: 'auto'}}>
            <Grid container justifyContent="center" item xs={12} className={modalClasses.accordionButton} onClick={() => {setOpenPhoneWeight(!openPhoneWeight)}} style={{marginTop: '15px'}}>
              <h4>Phone & Weight</h4>
              <IconButton aria-label="expand row" size="small" className={modalClasses.arrowIcons}>
                { openPhoneWeight ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon /> }
              </IconButton>
            </Grid>
            <Collapse in={openPhoneWeight} timeout="auto" unmountOnExit style={{width: '100%'}}>
              {!selectedPax ?
                <Grid container justifyContent="center" item xs={12} className={modalClasses.editRow} style={{paddingBottom: 0}}>
                  <span className={modalClasses.instructionText}>You need to select a passenger to edit a phone number or weight</span>
                </Grid> :
                <div></div>
              }
              <Grid container item xs={12} className={modalClasses.editRow}>
                <Grid item xs={2}></Grid>
                <Grid container justifyContent="center" item xs={4}>
                  <PhoneEdit pax={selectedPax} changeData={changeNewData} />
                </Grid>
                <Grid container justifyContent="center" item xs={4}>
                  <WeightEdit pax={selectedPax} changeData={changeNewData} />
                </Grid>
                <Grid container justifyContent="flex-start" alignContent="flex-end" item xs={1}>
                <p style={{marginBottom: '1px'}}> lbs</p>
                </Grid>
              </Grid>
            </Collapse>
            <Grid container justifyContent="center" item xs={12} className={modalClasses.accordionButton} onClick={() => {setOpenApfaxEdit(!openApfaxEdit)}} >
              <h4>Add Apfax</h4>
              <IconButton aria-label="expand row" size="small" className={modalClasses.arrowIcons}>
                { openApfaxEdit ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon /> }
              </IconButton>
            </Grid>
            <Collapse in={openApfaxEdit} timeout="auto" unmountOnExit style={{width: '100%'}}>
              <Grid container justifyContent="center" item xs={12} className={modalClasses.editRow}>
                <ApfaxEdit pax={selectedPax} flight={flight} changeData={changeNewData} modalClasses={modalClasses} />
              </Grid>
            </Collapse>
            <Grid container justifyContent="center" item xs={12} className={modalClasses.accordionButton} onClick={() => {setOpenAddRemark(!openAddRemark)}} >
              <h4>Add Remark</h4>
              <IconButton aria-label="expand row" size="small" className={modalClasses.arrowIcons}>
                { openAddRemark ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon /> }
              </IconButton>
            </Grid>
            <Collapse in={openAddRemark} timeout="auto" unmountOnExit style={{width: '100%'}}>
              <Grid container justifyContent="center" item xs={12} className={modalClasses.editRow}>
                <AddRemark pax={selectedPax} changeData={changeNewData} modalClasses={modalClasses} />
              </Grid>
            </Collapse>
            <Grid container justifyContent="center" item xs={12} style={{marginBottom: '8px', marginTop: '10px'}}>
              <Button variant="contained" onClick={() => {saveChanges(selectedPax, newData, setOpenStatusEdit)}} disabled={!selectedPax && !newData?.apfax?.rloc} style={{backgroundColor: '#03fc66', marginRight: '8px'}}>Save Changes</Button>
              <Button variant="contained" onClick={() => {props.closeModal()}} style={{backgroundColor: '#eb494e'}}>Close</Button>
            </Grid>
          </Grid>
        </Paper> : 
        <Paper className={modalClasses.editPaxSendingPaper}>
          <Grid container item xs={12} justify="center">
            <StatusList />
          </Grid>
          <Grid container item xs={12} justify="center">
            <Button variant="contained" onClick={() => {props.closeModal()}} style={{backgroundColor: '#eb494e'}}>Close</Button>
          </Grid>
        </Paper>
      }
    </Grid>
  )
}

export default EditPaxModal